<template>
    <div class="top-banner" :style="{backgroundImage:'url('+imgUrl+')'}">
        <div class="container">
            <div class="title">{{pageTitle}}</div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        props:['imgUrl','pageTitle']
    }
</script>

<style lang="scss" scoped>
    .top-banner{
        height: 490px;
        background-size: cover;
        background-position: center;
    }
    .container{
        position: relative;
        height: 100%;
    }
    .title{
        font-size: 57px;
        color: #fff;
        @include tb;
        font-weight: 500;
    }
</style>